import httpClient from "../http/http-client";
import { IReneweableEnergyCertificate, IPostRenewableEnergyCertificate } from './renewable-energy-certificate.model';

export default class RenewableEnergyCertificateService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IReneweableEnergyCertificate[]> {
    return this.http.get(`renewable-energy-certificate`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllActive(): Promise<IReneweableEnergyCertificate[]> {
    return this.http.get(`renewable-energy-certificate?active=true`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllWithPagination(searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IReneweableEnergyCertificate[] }> {
    return this.http.get(`renewable-energy-certificate?nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getOne(id: string, queryString?: string): Promise<IReneweableEnergyCertificate> {
    return this.http.get(`renewable-energy-certificate/${id}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async create(rec: IPostRenewableEnergyCertificate): Promise<IReneweableEnergyCertificate> {
    return this.http.post(`renewable-energy-certificate`, rec)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async createWithFile(form: FormData): Promise<IReneweableEnergyCertificate> {
    return this.http.post(`renewable-energy-certificate`, form)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async update(id: string, form: FormData): Promise<IReneweableEnergyCertificate> {
    return this.http.patch(`renewable-energy-certificate/${id}`, form)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async delete(id: string): Promise<IReneweableEnergyCertificate> {
    return this.http.delete(`renewable-energy-certificate/${id}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}


